'use strict';

let initialized = false;
let enabled = false;
let userId = null;

/**
 * LINE LIFF対応
 */
export default {
  _injectLiffScript(){
    return new Promise((resolve)=>{
      let script    = document.createElement('script');
      script.onload = ()=>{
        resolve();
      };
      script.src    = 'https://static.line-scdn.net/liff/edge/2.1/sdk.js';
      document.head.appendChild(script);
    });
  },
  
  /**
   * LIFFの初期化
   * @returns {boolean}
   */
  initialize(){
    if (initialized){
      return false;
    }
    
    this._injectLiffScript()
      .then(()=>{
        let liffId = process.env.LIFF_ID_CAMERA;
        
        return liff.init({liffId: liffId});
      })
      .then(()=>{
        initialized = true;
        enabled = liff.isInClient();
        // const context = liff.getContext();
        // alert(JSON.stringify(context));
        
        if(enabled){
          liff.getProfile()
            .then((profile)=>{
              //alert('SUCCESS' +  profile.userId);
              userId = profile.userId;
            })
          ;
        }
      })
      .catch((e)=>{
        //alert('初期化で問題が発生しました。一度このダイアログを閉じて再度カメラ起動ボタンを押してください。' + e);
      })
    ;
  },
  
  /**
   * LIFF有効化済？
   * @returns {boolean}
   */
  isEnabled(){
    return initialized && enabled;
  },
  
  /**
   * LINE User IDを取得
   * @returns {*}
   */
  getLineUserId(){
    return userId;
  }
};



// WEBPACK FOOTER //
// ./src/libs/line-liff.js